import '../css/footer.scss';
import { LastUpdated } from '../constants/Numbers';
import { Box, IconButton, Tooltip } from "@mui/material";
import { useThemeMode } from "../contexts/ThemeModeContext";

export default function Footer() {
  const { darkMode, toggleTheme } = useThemeMode();

  return (
    <footer>
      <hr />
      <div className="container footer-container">
        <p id="footer-container-left">
          <span>Créacirque by </span>
          <a target="_blank noreferrer" href="https://usidistrib.com">
            <b>Usidistrib</b>
          </a>
          <span> © 2026</span>
        </p>
        <p id="footer-container-right">
          Dernière mise à jour : {LastUpdated}
        </p>

        <Box
          sx={{
            position: "fixed",
            right: 16,
            bottom: 40,
            bgcolor: "background.paper",
            borderRadius: 2,
            boxShadow: 3,
            p: 1,
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <Tooltip title={darkMode ? "Basculer en mode clair" : "Basculer en mode sombre"}>
            <IconButton
              color="primary"
              aria-label="toggle theme"
              onClick={toggleTheme}
            >
              {darkMode ? "🌙" : "🌞"}
            </IconButton>
          </Tooltip>
        </Box>
      </div>
    </footer>
  );
};
